export const CertificateTestScoreModel = [
    {
        name: "TOEIC",
        score: 950,
        issuedDate: new Date("2026-03-17"),
        expiredDate: new Date("2028-03-17")
    },
]